module.exports = __webpack_public_path__ + "assets/img/box3_img1.da2fd38e.png";